function images() {
    return importAll(require.context('./', false, /\.(png|jpe?g|svg)$/));
}
function importAll(r) {
    return r.keys().map(r);
}
export default images